import { EmbeddingModel } from "@prisma/client";

export const CURRENT_EMBEDDING_MODEL = EmbeddingModel.OPENAI_TEXT_EMBEDDING_3_SMALL;
